export default {
  toasts: {
    auth_token_invalid: 'Token de autenticação inválido',
    host_access_refused:
      'Este endereço pertence a um parceiro do qual a sua conta não faz parte. Inicie sessão no seu próprio endereço.',
  },
};
